import { CostEvent } from "src/api/generated/erp/db/types/tables/costEvent.ts";
import { CostEventPriceListLine } from "src/api/generated/erp/db/types/tables/costEventPriceListLine.ts";
import dayjs, { Dayjs } from "dayjs";
import { currentLocalDateAsIsoString } from "src/utils/dayjsUtils.ts";

export function getCostEventFormDefaultValues({
	costEvent,
	priceListLines,
	storedItemId,
}: {
	costEvent: CostEvent | null | undefined;
	priceListLines: CostEventPriceListLine[];
	storedItemId: number | undefined;
}): CostEvent {
	if (costEvent != null) return costEvent;
	const eventDate = currentLocalDateAsIsoString();
	const priceListLine = findPriceListLineForCostEventItem({
		itemId: storedItemId ?? null,
		eventDate: dayjs(eventDate),
		priceListLines,
	});
	return {
		itemId: storedItemId as number,
		eventDate,
		cost: priceListLine?.cost ?? null,
		price: priceListLine?.price ?? null,
		explanation: "",
	} as CostEvent;
}

export function findPriceListLineForCostEventItem({
	itemId,
	eventDate,
	priceListLines,
}: {
	itemId: number | null;
	eventDate: Dayjs;
	priceListLines: CostEventPriceListLine[];
}): CostEventPriceListLine | undefined {
	if (itemId == null || !eventDate) return undefined;
	return priceListLines
		.filter((l) => l.costEventItemId === itemId && dayjs(l.validFrom) <= eventDate)
		.sort((a, b) => (b.validFrom > a.validFrom ? 1 : -1))[0];
}
